export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10806.9fc1492c.jpg";